import { Button } from '@/components/ui/Button'
import { noAccessReason } from '@/auth/profile'
import type { NoAccessReason } from '@/auth/profile'
import { useAuth } from '@/auth/SessionProvider'
import { AuthLayout } from './AuthLayout'

const MESSAGES: Record<NoAccessReason, { title: string; body: string }> = {
  'no-record': {
    title: 'Your account is not set up yet',
    body: 'Your login works, but you have not been added to the church records. Ask the church treasurer or an administrator to finish setting you up, then sign in again.',
  },
  inactive: {
    title: 'Your account is switched off',
    body: 'This account has been turned off. If you think that is a mistake, please contact the church treasurer.',
  },
  'no-role': {
    title: 'Nothing has been assigned to you yet',
    body: 'You are signed in, but you have not been given a department or a role. Ask the church treasurer or an administrator to assign one, then sign in again.',
  },
}

export function NoAccessPage() {
  const { auth, signOut } = useAuth()
  const profile = auth.status === 'signed-in' ? auth.profile : null
  const m = MESSAGES[noAccessReason(profile) ?? 'no-role']
  return (
    <AuthLayout title={m.title}>
      <p className="text-body text-neutral leading-relaxed">{m.body}</p>
      <Button size="lg" variant="secondary" className="w-full mt-6" onClick={() => void signOut()}>
        Sign out
      </Button>
    </AuthLayout>
  )
}
